import { basicFilterInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { finArrangementsAdjActionTypes } from '../actions/actionTypes';

export const REDUCER_NAME = 'FinArrangementFilterList';

const updateFilterConfig = (state, action) => {
  if (action.data.systemDefault) {
    return {
      ...state,
      systemDefaultFilter: action.data.systemDefault || null,
      selectedFilter: action.data.selectedItem || null,
      userDefaultFilter: action.data.userDefault || null,
    };
  }
  if (action.data.userDefault === null || action.data.userDefault) {
    return {
      ...state,
      selectedFilter: action.data.selectedItem || null,
      userDefaultFilter: action.data.userDefault,
    };
  }
  return {
    ...state,
    selectedFilter: action.data.selectedItem || null,
  };
};

const logAccOptsListReq = (state, action) => ({
  ...state,
  loading: true,
  listRequest: action.data ? action.data : state.listRequest,
  listRequestedOn: new Date(),
});

const getEditItemDetailsResponse = (state, action) => ({
  ...state,
  getEditItemDetails: action.data,
});

const updateTableConfig = (state, action) => ({
  ...state,
  isDistinctActive: action.data ? action.data.detail.isDistinct : null,
  listGroupBy: action.data ? action.data.detail.groupByParameters : null,
  listParamOptions: action.data ? action.data.detail.parameters : null,
  listColumnOrder: action.data ? action.data.detail.columnOrders : null,
  listSortOptions: action.data ? action.data.detail.sortOptions : null,
  selectedFilter: action.data ? action.data : null,
});

const finArrFilterListConfig = (state = { ...basicFilterInitialState }, action = null) => {
  switch (action.type) {
    // config list column configuration
    case finArrangementsAdjActionTypes.UPDATE_FILTER_CONFIG:
      return updateFilterConfig(state, action);
    case finArrangementsAdjActionTypes.UPDATE_TABLE_CONFIGURATION:
      return updateTableConfig(state, action);
    case finArrangementsAdjActionTypes.REMOVE_USER_DEFAULT_FILTER:
      return {
        ...state,
        userDefaultFilter: null,
      };
    default:
      return null;
  }
};

const finArrFilterListREQRES = (state = { ...basicFilterInitialState }, action = null) => {
  switch (action.type) {
    // log request
    case finArrangementsAdjActionTypes.GET_FINARRANGEMENTS_LIST_LOG_REQ:
      return logAccOptsListReq(state, action);
    // log error
    case finArrangementsAdjActionTypes.GET_FINARRANGEMENTS_LIST_ERROR:
      return {
        ...state,
        listRequestError: action.data,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    // store response
    case finArrangementsAdjActionTypes.GET_FINARRANGEMENTS_LIST_RESPONSE:
      return {
        ...state,
        listData: action.data,
        listRequestError: null,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    case finArrangementsAdjActionTypes.GET_NOTIF_USERS_BY_ID_RESPONSE:
      return getEditItemDetailsResponse(state, action);
    case finArrangementsAdjActionTypes.RESET_FINARRANGEMENTS_STORE:
      return {
        ...state,
        listData: null,
        listRequestError: null,
        listRequestProcessedOn: null,
        serverRequestError: null,
        loading: false,
      };
    case commonTypes.RESETSTORE:
      return basicFilterInitialState;
    default:
      return null;
  }
};
const FinArrangementFilterList = (state = { ...basicFilterInitialState }, action = null) => {
  const stateConfig = finArrFilterListConfig(state, action);
  const stateReqRes = finArrFilterListREQRES(state, action);
  if (stateConfig !== null) {
    return stateConfig;
  }
  if (stateReqRes !== null) {
    return stateReqRes;
  }
  return state;
};

export default FinArrangementFilterList;
